import { createExperimentHook } from '@prisjakt/ui-experiment';

export const useProductCollectionSuggestionsExperiment = createExperimentHook(
  'suggest-product-collections',
  { showProductCollectionSuggestions: false },
  {
    'suggest-product-collections': {
      showProductCollectionSuggestions: true,
    },
  }
);

export const useProductVariantsExperiment = createExperimentHook(
  'product-variants',
  false,
  { show: true }
);

export const useIncludePriceOnProductSuggestions = createExperimentHook(
  'suggest-show-product-prices',
  false,
  {
    showPrices: true,
  }
);

// A copy of this hook exist in components/product-card/src/product-card.js
export const useCategoriesLargerImagesForMobile = createExperimentHook(
  'categories-lager-images-for-mobile',
  false,
  { 'larger-image': true }
);
